import React from 'react';
import { Home, Zap, Bot, Search, Menu } from 'lucide-react';

/** Mobil sabit alt bar: en çok kullanılan sayfalar + tüm sayfaların bulunduğu Menü. */
export const MOBILE_TAB_LIST = [
    { id: 'home', path: '/', label: 'Ana Sayfa', icon: Home },
    { id: 'sinyaller', path: '/sinyaller', label: 'Sinyaller', icon: Zap },
    { id: 'bot', path: '/bot', label: 'Botlar', icon: Bot },
    { id: 'coin', path: '/coin', label: 'Coin', icon: Search },
    { id: 'menu', path: null, label: 'Menü', icon: Menu },
];

export default function MobileBottomNav({ activePath, onChange, onMenu }) {
    return (
        <nav
            data-testid="mobile-bottom-nav"
            className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-slate-900/95 backdrop-blur border-t border-slate-700 pb-[env(safe-area-inset-bottom)]"
        >
            <ul className="grid grid-cols-5">
                {MOBILE_TAB_LIST.map(({ id, path, label, icon: Icon }) => {
                    const isActive = path !== null && activePath === path;
                    return (
                        <li key={id} className="relative">
                            {isActive && <span className="absolute top-0 inset-x-3 h-0.5 rounded-b bg-emerald-400" />}
                            <button
                                data-testid={`bottom-nav-${id}`}
                                aria-current={isActive ? 'page' : undefined}
                                onClick={() => (path === null ? onMenu?.() : onChange?.(path))}
                                className={`w-full flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors ${
                                    isActive ? 'text-emerald-300' : 'text-slate-400 active:text-emerald-400'
                                }`}
                            >
                                <Icon className="h-5 w-5" />
                                <span className="text-[10px] font-medium tracking-tight">{label}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
